<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui";
	import DefaultLoading from "@hitit/new_ui/src/SVG/DefaultLoading.svelte";
	import RefreshIcon from "@hitit/new_ui/src/SVG/RefreshIcon.svelte";
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import { createEventDispatcher } from "svelte";
	import PointNameValue from "./PointNameValue.svelte";
	//Types
	type ChanelStatus = {
		channelId: string;
		channelName: string;
		channelStatus: string;
		useSmsFailover: boolean;
	};
	//Props
	export let isLoading = false;
	export let channelStatus: ChanelStatus = {
		channelId: "",
		channelName: "",
		channelStatus: "",
		useSmsFailover: false,
	};
	//Constants
	//Variables
	const dispatch = createEventDispatcher();
	let editmode = false;
	export let value = "";

	//Functions
	function channelRefresh() {
		dispatch("channelRefresh");
	}
	function actionHandler() {
		if (editmode) {
			dispatch("channelIdChange", {
				id: value,
			});
		}
		editmode = !editmode;
	}
	//Do
</script>

<Card>
	<div class="container">
		<div class="title-box">
			<div class="title-text">{$t("global.point.Kakao_chanel")}</div>
			<div id="refresh" on:click={channelRefresh}>
				<RefreshIcon loading={isLoading} />
			</div>
		</div>
		{#if isLoading}
			<div class="loading">
				<DefaultLoading />
			</div>
		{:else}
			<div class="name-value-box">
				<PointNameValue
					name={$t("mbr.point.kakao_channel_id")}
					input
					placeholder={"기본은 @hititpoint입니다"}
					bind:value={value}
					editmode={editmode}
				>
					<div slot="button" class="action" on:click={actionHandler}>
						{#if editmode}
							<span class="save">{$t("global.save")}</span>
						{:else}<img src={EditIcon} alt="editIcon" />{/if}
					</div>
				</PointNameValue>
			</div>
			<span class="status">{$t("mbr.point.status")}</span>
			<div class="status-box">
				<PointNameValue
					text={"채널아이디"}
					value={`"${channelStatus.channelId}"`}
				/>
				<PointNameValue
					text={"채널이름"}
					value={`"${channelStatus.channelName}"`}
				/>
				<PointNameValue
					text={"채널상태"}
					value={`"${channelStatus.channelStatus}"`}
				/>
				<PointNameValue
					text={"SMS사용여부"}
					value={String(channelStatus.useSmsFailover)}
				/>
			</div>
		{/if}
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.loading {
		width: 30px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
	}
	.container {
		display: flex;
		flex-direction: column;
		width: 100%;

		.title-box {
			display: flex;
			justify-content: space-between;

			#refresh {
				width: 27px;
				height: 27px;
				margin-top: -10px;
				cursor: pointer;
			}

			.title-text {
				font-size: 1.25rem;
				font-weight: 600;
				color: #46474b;
			}
		}

		.name-value-box {
			display: flex;
			padding: 20px 0px;

			.action {
				display: flex;
				flex-direction: column-reverse;

				img {
					width: 26px;
					cursor: pointer;
				}
			}
		}

		.status {
			letter-spacing: -0.64px;
			color: #46474b;
			margin-bottom: 10px;
		}
		.status-box {
			display: flex;
			flex-direction: column;
		}
		.save {
			font-weight: 500;
			cursor: pointer;
			color: #6591fa;
		}
	}

	@include DesktopSize {
		.container {
			.save {
				font-size: 1.25rem;
				color: #6591fa;
			}
			.title-box {
				.title-text {
					font-size: 2.1875rem;
				}
				#refresh {
					margin-top: 0px;
				}
			}
			.status {
				font-size: 1.25rem;
			}
			.status-box {
				gap: 5px;
			}
		}
	}
</style>
